<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="icon fail"></div>
        <div class="textArea flex">
          <h5>{{ t('skillCertify-caution') }}</h5>
          <p v-html="description" />
        </div>
        <div class="boxArea">
          <p class="red">
            {{ [1, 2, 3, 4].map(i => t(`skillCertify-caution-short-cut-key-word-${i}`)).join(', ') }}
          </p>
        </div>
        <div class="btnArea">
          <button @click.stop="onClickClose">{{ t('common-continue') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import DialogType from "~~/application/components/Common/Dialog/model/DialogType";
import { convertToNextLine } from "~~/application/utils/StringUtil";

const { t } = useI18n();
const dialogStore = useDialogStore();

const description = computed(() => {
  return `${convertToNextLine(t('skillCertify-caution-short-cut-1'))} <br/><span class='white'>${t('skillCertify-caution-short-cut-2')}</span>`
})

const onClickClose = () => {
  dialogStore.deleteMultiOption({
    type: DialogType.CautionShortCutPopup
  })
};

</script>

